
import Home from './Components/home'
const App = () => {
  return (
    <Home/>
  )
}

export default App